const shouldCancelActiveRun = (activeMessageId, targetMessageId) => {
  return Boolean(activeMessageId && activeMessageId !== targetMessageId)
}

module.exports = { shouldCancelActiveRun }
